import React from "react";
import { Box } from "@mui/material";
import { LOGIN_REACHIQ_LOGO, SORRY_IMAGE } from "../../utils/constants/assets";
import { styles } from "./styles";

import { Anchor, RightsTag } from "../../components";
import {
  PRIVACY_POLICY_LINK,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";
import Typography from "../../components/Typography/Typography";
import { GREY } from "../../utils/colors";
import { fontWeight } from "../../utils/constants/UI";
import Button from "../../components/Buttons/Button";
import { Strings } from "./strings";
import Image from "../../image/Image";
import { REACHIQ_HOME } from "../../utils/constants/httpConstants";

const InvalidTokenScreen = () => {
  const classes = styles();

  const handleNavigation = () => {
    window.location.href = REACHIQ_HOME;
  };

  return (
    <Box className={classes.Head}>
      <Box className={classes.logo_container}>
        <Image
          onClick={handleNavigation}
          src={LOGIN_REACHIQ_LOGO}
          className={classes.reachiqLogo}
        />
      </Box>
      <Box className={classes.invalidContentContainer}>
        <Image className={classes.Image} src={SORRY_IMAGE} />

        <div className={classes.sorryTitle}>
          {" "}
          <Typography
            size={"dsm"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.INVALID_TOKEN}
          />
        </div>
        <div className={classes.SubHead}>
          <Typography
            size={"sm"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.INVALID_TOKEN_DESC}
          />
          
        </div>
        <p className={classes.sorryPara}></p>
        <Box className={classes.Top}>
          {" "}
          <Button
            size={"sm36"}
            variant={"primary"}
            label={Strings.GO_HOME}
            onClick={handleNavigation}
          />
        </Box>
      </Box>
      <Box>
        <div className={classes.containPolicy}>
          <RightsTag className={classes.termsPara} />
          {/* Privacy and Terms. */}
          <Anchor
            href={PRIVACY_POLICY_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            {Strings.PRIVACY}
          </Anchor>
          <div className={classes.TypoHead}>
            <Typography
              label={Strings.AND}
              color={GREY.QUATINARY}
              size={"xs"}
              fontWeight={fontWeight.REGULAR}
            />
          </div>
          <Anchor
            href={TERMS_SERVICE_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            {Strings.TERMS}
          </Anchor>
        </div>
      </Box>
    </Box>
  );
};

export default InvalidTokenScreen;
